enum FormNames {
  AffiliatesInfoForm = 'affiliatesInfoForm',
  AuthorizationDetailForm = 'authorizationDetailsForm',
  BrandCertificationForm = 'vendorBrandCertificationForm',
  CancelContractForm = 'cancelContractForm',
  CommentForm = 'commentForm',
  ContractEmailForm = 'contractEmailForm',
  ContractResaleEmailForm = 'contractResaleEmailForm',
  CoverageForm = 'coverageForm',
  CustomerForm = 'customerForm',
  CustomerInfoForm = 'customerInfoForm',
  EscrowInfoForm = 'escrowInfoForm',
  EscrowOfficeForm = 'escrowOfficeForm',
  EscrowOfficerForm = 'escrowOfficerForm',
  FileUploadForm = 'fileUploadForm',
  HiddenPayeezyTestForm = 'hiddenPayeezyLaunchForm',
  InvoiceLineCreate = 'invoiceLineCreate',
  LoginForm = 'loginForm',
  NoRenewForm = 'noRenewContractForm',
  PaymentForm = 'paymentForm',
  PriceAdjustmentForm = 'priceAdjustmentForm',
  ProfileForm = 'profileForm',
  PropertyInfoForm = 'propertyInfoForm',
  PropertyManagementOfficeForm = 'PropertyManagementOfficeForm',
  PropertyManagerForm = 'propertyManagerForm',
  PurchaseApplianceInfoForm = 'purchaseApplianceInfoForm',
  PurchaseHvacForm = 'purchaseHvacForm',
  PurchaseHvacItemForm = 'purchaseHvacItemForm',
  PurchasePartsForm = 'purchasePartsForm',
  PurchasePartsItemForm = 'purchasePartsItemForm',
  RealEstateAgentForm = 'realEstateAgentForm',
  RealEstateAssistantForm = 'realEstateAssistantForm',
  RealEstateOfficeForm = 'realEstateOfficeForm',
  ServiceWorkOrderForm = 'serviceWorkOrderForm',
  TransactionCoordinatorForm = 'transactionCoordinatorForm',
  UserForm = 'userForm',
  VendorAddressNFinances = 'vendorAddressNFinancesForm',
  VendorCoverageNLimits = 'vendorCoverageNLimitsForm',
  VendorDefaultRatings = 'vendorDefaultRatingsForm',
  VendorGeneralInfo = 'vendorGeneralInfoForm',
  VendorTradeMaintenance = 'vendorTradeMaintenance',
  VendorTradeTripCharges = 'vendorTradeTripCharges',
  VendorZipsForm = 'vendorZipsForm'
}

export default FormNames;



// WEBPACK FOOTER //
// ./src/_constants/FormNames.enum.ts